module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-76-min.bc570e59.jpg";